import { type CompetitorAttributes } from './generated/CompetitorAttributes';
import ApplicationModel, { attr } from '../ApplicationModel';
import { model } from '../modelBuilder';

interface Competitor extends CompetitorAttributes {}

@model
class Competitor extends ApplicationModel {
  static terminologyName = 'Competitor';

  // Start auto-generated
  static typename: 'Competitor' = 'Competitor';
  get typename(): 'Competitor' {
    return 'Competitor';
  }

  static internalTypename: 'Competitor' = 'Competitor';
  get internalTypename(): 'Competitor' {
    return 'Competitor';
  }

  static filterType = 'CompetitorFilters!';
  static filters = { id: '[ID!]', projectId: 'ID' };

  static fields = {
    commentsCount: attr({ readable: true }),
    id: attr({ readable: true }),
    name: attr({ readable: true }),
    path: attr({ readable: true }),
    projectId: attr({ readable: true }),
    referenceNum: attr({ readable: true }),
    project: attr.belongsTo({ readable: true, typename: 'Project' }),
    comments: attr.hasMany({ readable: true }),
    tasks: attr.hasMany({ readable: true }),
  };
  // End auto-generated
}

export default Competitor;
